import { memo, type PropsWithChildren, useMemo } from 'react';

import { GalleryItemType } from '~/components/Gallery/types';
import {
  type AssetDragItem,
  DNDMovableToBoardItem,
} from '~/components/Shared/Drag/DNDMovableToBoardItem/DNDMovableToBoardItem';
import { DNDParentAsset } from '~/components/Shared/Drag/DNDParentAsset';
import { DragType } from '~/components/Shared/Drag/dragTypes';
import { DropHighlight } from '~/components/Shared/DropHighlight';
import { type PrivateAssetTableRowProps } from '~/components/TableView/PrivateTableView/PrivateAssetTableRow';
import { DROPHIGHLIGHT_STYLES, TABLE_ROW_HEIGHT } from '~/components/TableView/ui';
import { getAssetGalleryItemType } from '~/utils/AssetUtils';

type PrivateDraggableAssetTableRowProps = {
  asset: PrivateAssetTableRowProps['data'];
};

export const PrivateDraggableAssetTableRow = memo(
  ({ children, asset }: PropsWithChildren<PrivateDraggableAssetTableRowProps>) => {
    const itemType = getAssetGalleryItemType(asset);

    const draggableItem: AssetDragItem = useMemo(
      () => ({
        asset,
        assetId: asset.assetId,
        type: itemType === GalleryItemType.asset ? DragType.asset : DragType.file,
      }),
      [asset, itemType],
    );

    return (
      <DNDParentAsset dropLocation="asset" asset={asset} style={{ height: TABLE_ROW_HEIGHT }}>
        <DropHighlight style={DROPHIGHLIGHT_STYLES} />
        <DNDMovableToBoardItem id={asset.id} item={draggableItem} enabled={true}>
          {children}
        </DNDMovableToBoardItem>
      </DNDParentAsset>
    );
  },
);

PrivateDraggableAssetTableRow.displayName = 'PrivateDraggableAssetTableRow';
